import { IconLookup, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import React, { MouseEvent, useState } from 'react';

interface Props {
    title: string;
    trigger?: 'hover' | 'click';
    icon: IconLookup;
    iconStyle?: React.CSSProperties
    icon2?: IconLookup;
    icon2Style?: React.CSSProperties;
    disabled?: boolean;
    toggled?: boolean; // if defined the icon behaves as a toggler instead of a regular button
    style?: React.CSSProperties;
    size?: SizeProp
    placement?: TooltipPlacement;
    onClick?: (evt: MouseEvent) => void;
}

export const TooltipIcon: React.FC<Props> = ({
    title,
    trigger,
    icon,
    iconStyle,
    icon2,
    icon2Style,
    disabled,
    toggled,
    size,
    style,
    placement,
    onClick
}) => {

    // states
    const [hover, setHover] = useState(false);

    // getters
    const getStyle = (): React.CSSProperties => {

        if (disabled) {
            return {
                cursor: 'not-allowed',
                color: 'var(--gray-5)'
            };
        }

        if (toggled === true) {
            return {
                cursor: 'pointer',
                color: 'var(--primary-6)'
            }
        }

        if (toggled === false) {
            return {
                cursor: 'pointer',
                color: 'var(--gray-6)'
            }
        }

        const internalStyle: React.CSSProperties = { cursor: 'pointer' };
        if (hover)
            internalStyle.color = 'var(--primary-6)';
        else
            internalStyle.color = 'inherit';
        return internalStyle; // { ...internalStyle, ...style };
    }

    // handlers
    const handleClick = (evt: MouseEvent) => {
        if (disabled)
            return;
        if (onClick)
            onClick(evt);
    }

    // renderers

    return (
        <Tooltip title={title} trigger={trigger} placement={placement} style={style}>
            {!icon2 ? (
                <FontAwesomeIcon
                    icon={icon}
                    size={size}
                    onMouseEnter={e => setHover(true)}
                    onMouseLeave={e => setHover(false)}
                    onClick={handleClick}
                    style={getStyle()} />

            ) :
                (
                    <div style={style}>
                        <span
                            style={{ ...getStyle(), position: 'relative' }}
                            onMouseEnter={e => setHover(true)}
                            onMouseLeave={e => setHover(false)}
                            onClick={handleClick}>
                            <FontAwesomeIcon
                                style={iconStyle}
                                icon={icon}
                                size={size} />
                            <FontAwesomeIcon
                                style={icon2Style}
                                icon={icon2}
                                size={size} />
                        </span>
                    </div>

                )}
        </Tooltip>
    );

}

export default TooltipIcon;